import React from 'react';
import { FaAlipay } from "react-icons/fa";
import { RiChinaRailwayLine } from "react-icons/ri";
import { GiProgression } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';

import './TransactionCardJ1.scss';


const TransactionCard = () => {
  const navigate = useNavigate();  // Hook for navigation

  // Function to redirect to a new page
  const redirectToNewPage = () => {
    navigate('/Ras'); // Specify the path to your new page here
  }

  return (
    <div className="transaction-card">      
      <div className="transaction-header">
        <div className="left">
        <span><GiProgression  className='gi'/> security services</span>
        </div>
        <div className="right">
          <div className="date-time">2024-02-24 17:09:45</div>
          <div className="status">Urgent...</div>
        </div>
      </div>
      <div className="transaction-body" onClick={redirectToNewPage}>
        <div className="left">
          <span className="icon currency-icon"><RiChinaRailwayLine className='ri'/> transaction consumption CNY </span>
        </div>
        <div className="right">
          <span className="amount">2024-02-24 17:09:45</span>
        </div>
      </div>
      <div className="info-item">
          <span className="status-label">Order Status</span>
          <span className="status-value"></span>
        </div>
      <div className="transaction-info">
        <div className="info-item">
          <span className="method">payment method<FaAlipay className='fa' /> transaction consumption CNY</span>
          <span className="method-value">220.00</span>
        </div>
        <div className="info-item">
          <span className="status-label">Order Status</span>
          <span className="status-value"></span>
        </div>
      </div>      
    </div>
  );
}

export default TransactionCard;
